<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Vídeos')"></BreadcrumSection>

    <h1>{{ $t("Vídeos") }}</h1>

    <MaterialsCommon init-query="activitat_comunitat:videodocent" router-name="videos"></MaterialsCommon>

  </div>

</template>

<script>

import store from "@/store";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {setMetadata} from "@/composables/metadataFunctions";
import MaterialsCommon from "@/components/MaterialsCommon.vue";
import {onMounted} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

export default {
  name: "VideosView",
  components: {
    MaterialsCommon,
    BreadcrumSection
  },

  setup(){
    const route = useRoute();
    const { t } = useI18n();

    onMounted(async () => {
      setMetadata(t('Vídeos'))
      await store.dispatch('updateSearchSelected', "Vídeos");
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-video.webp') });
    });

    return{
    }
  }
}

</script>

<style scoped>
</style>
